import styled from "@emotion/styled";
import { ListBox, ListBoxItem } from "react-aria-components";

export const StyledMDSListBox = styled(ListBox)`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  width: max-content;
  max-width: 90vw;
  overflow-y: auto;
  scrollbar-width: none;

  > [role="option"] {
    grid-column: 1 / -1;
    min-width: 0;
  }

  [data-mds-name="mds-menu-item-tooltip-trigger"] {
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
    min-width: 0;
  }

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const StyledListBoxItem = styled(ListBoxItem)`
  display: grid;
  grid-template-columns: subgrid;
  grid-column: 1 / -1;
  min-width: 0;
`;
